(function(angular, module) {var resolveSurvey, resolveSurveys, stateDefinitions;

stateDefinitions = function($stateProvider) {
  'ngInject';
  $stateProvider.state('program.annualSurvey', {
    url: '/survey',
    abstract: true,
    permission: 'viewAnnualSurveys',
    templateUrl: 'empty'
  });
  $stateProvider.state('program.annualSurvey.index', {
    url: '',
    templateUrl: 'programs/annualSurvey/index',
    resolve: {
      surveys: resolveSurveys
    },
    controllerAs: 'ctrl',
    controller: function(surveys, moment) {
      var today;
      this.surveys = surveys;
      today = moment();
      this.lastCompletedEnd = today.year();
      if (today.quarter() !== 4) {
        this.lastCompletedEnd -= 1;
      }
      this.currentStart = this.lastCompletedEnd;
      this.currentEnd = this.currentStart + 1;
      return this.nextStart = this.currentEnd;
    }
  });
  return $stateProvider.state('program.annualSurvey.view', {
    url: '/{year:int}',
    templateUrl: 'programs/annualSurvey/view',
    resolve: {
      survey: resolveSurvey
    },
    controllerAs: 'ctrl',
    controller: function(survey) {
      this.survey = survey;
    }
  });
};


/* @ngInject */

resolveSurveys = function(ModelService, program) {
  return ModelService.getModelRelation(program, 'annual_surveys');
};


/* @ngInject */

resolveSurvey = function($stateParams, program, ModelService) {
  var id;
  id = "annual_surveys/" + $stateParams.year;
  return ModelService.getModelRelation(program, id);
};

module.config(stateDefinitions);
})(angular, angular.module("dybAnnualSurvey"));